import React from 'react';

import ProfileAddresses from '../components/ProfileAddresses';
import PageContainer from '../layouts/PageContainer';

export default function MyAddresses() {
  return (
    <PageContainer title="My Addresses">
      <ProfileAddresses />
    </PageContainer>
  );
}
